/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeSaveSignupProgressRequest, type ErrorResponse, type InternalErrorResponse, type SaveSignupProgressRequest } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/signups/progress
 */
export interface ProgressRequestBuilder extends BaseRequestBuilder<ProgressRequestBuilder> {
    /**
     * Saves what someone has entered on the sign-up form so far, when they move on to the next step. If they stop before their organization is created, the Nymble team is told an hour later so someone can follow up. Blank fields keep what an earlier step saved. Rate limited, and only accepted from the sign-up page's own origins.
     * @param body What the sign-up form holds when someone clicks Next or Create account. Only the email is required;every other field is whatever the steps so far have collected, and a blank one keeps what an earliersave captured.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 429 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SaveSignupProgressRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Saves what someone has entered on the sign-up form so far, when they move on to the next step. If they stop before their organization is created, the Nymble team is told an hour later so someone can follow up. Blank fields keep what an earlier step saved. Rate limited, and only accepted from the sign-up page's own origins.
     * @param body What the sign-up form holds when someone clicks Next or Create account. Only the email is required;every other field is whatever the steps so far have collected, and a blank one keeps what an earliersave captured.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SaveSignupProgressRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ProgressRequestBuilderUriTemplate = "{+baseurl}/api/signups/progress";
/**
 * Metadata for all the requests in the request builder.
 */
export const ProgressRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ProgressRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSaveSignupProgressRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
